import api from './interceptor';

const BASE_URL_V2 = 'api/v2/providers';

export default {
  // API Version 2
  getProviderFilters: (params) => api.get(`${BASE_URL_V2}/filters`, { params }),
  searchProviders: (params) => api.get(`${BASE_URL_V2}/available`, { params }),
  getReasons: params => api.get(`${BASE_URL_V2}/reasons`, { params }),
  setReasons: reasons => api.post(`${BASE_URL_V2}/reasons`, reasons),
  getTimeSlotsByDate: params => api.get(`${BASE_URL_V2}/${params.providerId}/timeslots/${params.date}`, { params }),
  getProviderAddedQuestions: (accountId) => api.get(`${BASE_URL_V2}/${accountId}/questions`),
  addProviderQuestions: (accountId, data) => api.post(`${BASE_URL_V2}/${accountId}/questions/add-batch`, data),
  removeProviderQuestions: (accountId, data) => api.delete(`${BASE_URL_V2}/${accountId}/questions/remove-batch`, data),
  getFavoriteProviders: () => api.get(`${BASE_URL_V2}/favorites/`),
  toggleFavorite: (providerId, params) => api.patch(`${BASE_URL_V2}/favorite/${providerId}`, params),
  getAvailableUrgentProviders: (params) => api.get(`${BASE_URL_V2}/available-urgent`, params),
};
